import React from "react";
import Chip from "@mui/material/Chip";
import { getContentReviewStatus } from "../utils/contentReviewStatus";
import { isReviewModeEnabled } from "../utils/reviewMode";

const TONE_STYLES = {
  success: {
    color: "#2f6b45",
    backgroundColor: "rgba(91, 161, 111, 0.16)",
    borderColor: "rgba(91, 161, 111, 0.34)",
  },
  attention: {
    color: "#8a4b00",
    backgroundColor: "rgba(239, 125, 0, 0.14)",
    borderColor: "rgba(239, 125, 0, 0.34)",
  },
  missing: {
    color: "#9c3218",
    backgroundColor: "rgba(209, 77, 24, 0.14)",
    borderColor: "rgba(209, 77, 24, 0.34)",
  },
  new: {
    color: "#2b6870",
    backgroundColor: "rgba(136, 205, 211, 0.22)",
    borderColor: "rgba(60, 143, 153, 0.3)",
  },
  changed: {
    color: "#5c4a12",
    backgroundColor: "rgba(224, 190, 87, 0.18)",
    borderColor: "rgba(184, 145, 44, 0.3)",
  },
};

export default function ContentReviewChip({ status = "controleer", label, sx = {} }) {
  // Hidden by default in normal public UAT browsing — surfacing UAT review
  // statuses (Aangepast, Controleer tekst, etc.) only confuses visitors. The
  // chips reappear with `?review=1` in the URL or `windroosReview` in
  // localStorage so the review team can still inspect content state.
  if (!isReviewModeEnabled()) return null;
  const config = getContentReviewStatus(status);
  const tone = TONE_STYLES[config.tone] || TONE_STYLES.attention;
  const chipLabel = label || config.label;

  return (
    <Chip
      size="small"
      label={chipLabel}
      aria-label={`UAT inhoudsstatus: ${chipLabel}. ${config.description}`}
      sx={{
        alignSelf: "flex-start",
        height: 24,
        borderRadius: "999px",
        border: "1px solid",
        borderColor: tone.borderColor,
        backgroundColor: tone.backgroundColor,
        color: tone.color,
        fontFamily: "Poppins, sans-serif",
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: 0,
        "& .MuiChip-label": {
          px: 1,
          whiteSpace: "nowrap",
        },
        ...sx,
      }}
    />
  );
}
